<template>
  <div>
    <q-layout view="lHh Lpr lFf" v-if="!home">
      <!-- Init & Login screen -->
      <div class="window-height row justify-center items-center text-center q-mx-auto">
        <div class="col-9 col-md-3">
          <img alt="logo" src="@/assets/logo.png" href="/index" style="max-height:200px;min-width:auto">
          <div class="row justify-center items-center text-center">
            <div class="col-12 q-pt-md">
              <q-card-section>
                <div v-if="isAnonymous">
                  <q-input class="q-my-xs" v-model="id" placeholder="Nhập tên đăng nhập hoặc email">
                    <template v-slot:prepend>
                      <q-icon name="account_circle" />
                    </template>
                  </q-input>
                  <q-input class="q-my-xs" placeholder="Mật khẩu" v-model="password" :type="isPwd ? 'password' : 'text'"
                    v-on:keyup.enter="login()">
                    <template v-slot:prepend>
                      <q-icon name="lock" />
                    </template>
                    <template v-slot:append>
                      <q-icon :name="isPwd ? 'visibility_off' : 'visibility'" class="cursor-pointer"
                        @click="isPwd = !isPwd" />
                    </template>
                  </q-input>
                  <div class="column">
                    <q-btn ripple class="text-green-6 q-mt-md col" @click="login()" :outline="isAnonymous"
                      :flat="!isAnonymous" :loading="loading || !isAnonymous">
                      <q-icon name="home" left class="q-mr-sm"></q-icon>Đăng nhập
                    </q-btn>
                    <q-btn flat color="primary" @click="promptResetPass = true" label="Quên mật khẩu" class="col" />
                    <q-dialog v-model="promptResetPass" persistent>
                      <q-card style="min-width: 400px">
                        <q-card-section>
                          <div class="text-h6">Nhập email của bạn</div>
                        </q-card-section>

                        <q-card-section>
                          <q-input type="email" label="Email" clearable dense v-model="emailResetPass" autofocus
                            @keyup.enter="promptResetPass = false" />
                        </q-card-section>

                        <q-card-actions align="right">
                          <q-btn flat icon="clear" v-close-popup />
                          <q-btn flat @click="resetPass">
                            <q-icon v-show="!isEmailResetSending" name='check' style="font-size:2em"></q-icon>
                            <q-spinner-tail v-show="isEmailResetSending" color="blue-grey" />
                          </q-btn>
                        </q-card-actions>
                      </q-card>
                    </q-dialog>
                  </div>
                </div>
                <q-spinner-ball color="green-4" v-else size="5em" />
              </q-card-section>
            </div>
          </div>
        </div>
      </div>
    </q-layout>
    <template v-else>
      <q-layout view="lHh Lpr lFf">
        <q-header elevated reveal class="bg-grey-3 shadow-1" style="width: 100%">
          <q-toolbar>

            <q-toolbar-title>
              <router-link to="/" style="width:150px; text-decoration:none;color:#4caf50">Angkor Banana</router-link>
            </q-toolbar-title>
            <div>
              <q-btn color="grey" flat dense round @click="leftDrawerOpen = !leftDrawerOpen" aria-label="Menu"
                icon="menu" />
            </div>
          </q-toolbar>
        </q-header>
        <q-ajax-bar ref="top-loadding-bar" position="top" color="green-6" size="3px" skip-hijack />
        <q-drawer v-model="leftDrawerOpen" bordered content-class="bg-grey-2" side="right">
          <q-scroll-area style="height: calc(100% - 150px); margin-top: 150px; border-right: 1px solid #ddd">
            <q-list padding>
              <q-item v-for="(item) in menu" clickable q-ripple :key="item.title" :to="item.route" v-show="item.show">
                <q-item-section avatar>
                  <q-icon :name="item.icon" />
                </q-item-section>
                <q-item-section>{{item.title}}</q-item-section>
              </q-item>
              <q-item clickable q-ripple @click="$auth.logout">
                <q-item-section avatar>
                  <q-icon name="power_settings_new" />
                </q-item-section>
                <q-item-section>Đăng xuất</q-item-section>
              </q-item>
            </q-list>
          </q-scroll-area>
          <q-img class="absolute-top" :src="backgr" style="height: 200px;top:-50px">
            <div class="absolute-bottom bg-transparent">
              <q-avatar size="56px" class="q-mb-sm">
                <img :src="user.photoURL ? user.photoURL : myimg">
              </q-avatar>
              <div class="text-weight-bold">{{user.displayName ? user.displayName : user.email}}</div>
            </div>
          </q-img>
        </q-drawer>
        <q-page-container>
          <q-page style="padding-top: 20px" class="q-pa-md">
            <router-view :key="keyRouterView"></router-view>
          </q-page>
        </q-page-container>
      </q-layout>
    </template>
  </div>
</template>

<script>
import backgr from '@/assets/material.jpg'
import myimg from '@/assets/logo.png'
import { mapGetters } from 'vuex'

const MENU = [
  { route: '/plans', title: 'Kế hoạch', icon: 'assignment', show: true },
  { route: '/statistics', title: 'Báo cáo', icon: 'trending_up', show: true },
  { route: '/timekeeping', title: 'Chấm công', icon: 'assignment_ind', show: true },
  { route: '/reports', title: 'Chăm sóc lô', icon: 'assessment', show: true },
  { route: '/manage-order', title: 'Đơn hàng', icon: 'receipt', show: true },
  // { route: '/harvest', title: 'Thu hoạch', icon: 'local_florist', show: true },
  { route: '/categories', title: 'Danh mục', icon: 'category', show: true },
]

export default {
  data () {
    return {
      password: '',
      loading: false,
      isPwd: true,
      id: '',
      pass: '',
      leftDrawerOpen: this.$q.screen.width >= this.$q.screen.md,
      menu: null,
      myimg: myimg,
      keyRouterView: 1,
      backgr: backgr,
      promptResetPass: false,
      emailResetPass: '',
      isEmailResetSending: false
    }
  },
  created() {
  },
  computed: {
    home () {
      // eslint-disable-next-line
      this.loading = false
      return this.user && this.menu
    },
    user () {
      return this.$store.getters.user
    },
    permission () {
      return this.$store.getters.permission
    },
    ...mapGetters([
      'isAnonymous'
    ])
  },
  watch: {
    permission: function (newValue) {
      if (newValue && this.user) {
        this.checkModulesPermission()
      }
    },
    user: function (newValue) {
      if (newValue && !this._.isEmpty(newValue)) {
        this.menu = MENU
        this.checkModulesPermission()
      } else {
        this.menu = null
      }
    },
  },
  methods: {
    async login() {
      let vm = this
      vm.loading = true
      await vm.$auth.login(vm.id, vm.password).catch(error => {
        vm.$q.notify({
          message: `${error}`,
          color: 'red',
          icon: 'error'
        })
      vm.loading = false
      })
      vm.loading = false
    },
    async loginNafoods() {
      let vm = this
      vm.loading = true
      await vm.$auth.loginNafoods().catch(error => {
        vm.$q.notify({
          message: `${error}`,
          color: 'red',
          icon: 'error'
        })
      vm.loading = false
      })
      vm.loading = false
    },
    runScript(e) {
      if (e && (event.which == 13 || e.keyCode == 13)) {
        this.login()
      }
    },
    async resetPass() {
      this.isEmailResetSending = true
      await this.$auth.resetPass(this.emailResetPass).then(() => {
        this.isEmailResetSending = false
        this.$q.notify({
          message: 'Email khôi phục mật khẩu đã được gửi về email của bạn',
          color: 'black',
          icon: 'check'
        })
      }).catch(err => {
        this.$q.notify({
          message: `${err}`,
          color: 'red',
          icon: 'check'
        })
        this.isEmailResetSending = false
      })
    },
    checkModulesPermission() {
      if(!this.permission || !this.permission.roles) return
      let accept = ['F1M', 'F2M', 'F3M', 'F4M', 'F5M', 'BOM']
      if (this.permission && this._.intersection(accept, Object.keys(this.permission.roles)).length > 0) {
        this.menu = MENU
      } else if (this.permission && this._.intersection(accept, Object.keys(this.permission.roles)).length == 0) {
        this.menu = MENU.slice(2)
      } else {
        this.menu = null
      }
    }
  }
}
</script>

<style>
.q-drawer {
  position: fixed !important
}
</style>
